const minifyHtml = htmlStr => htmlStr.replace(/\\r?\\n/g, '').replace(/\s{1,}/g, '');

export default minifyHtml;
